import { useEffect } from "react";

import {
    getSessionStorageItem,
    setSessionStorageItem,
} from "@accurx/shared/dist/sessionStorageHelper";
import { useLocation } from "react-router-dom";

import { Values } from "../../shared/types/utils.types";

const SOURCE_TYPE = {
    App: "App",
    Web: "Web",
    Mobile: "Mobile",
} as const;

export type SourceType = Values<typeof SOURCE_TYPE>;

const mapProductSearchParamToSourceType = (
    productSearchParam: string | null,
): SourceType => {
    switch (productSearchParam) {
        case "1":
            return SOURCE_TYPE.App;

        case "2":
        default:
            return SOURCE_TYPE.Web;

        case "3":
            return SOURCE_TYPE.Mobile;
    }
};

export const SOURCE_TYPE_KEY = "SourceType";

export const useStoreSourceType = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const productParam = searchParams.get("product");

    useEffect(() => {
        if (productParam) {
            setSessionStorageItem(SOURCE_TYPE_KEY, productParam);
        }
    }, [productParam]);
};

export const getSourceType = (): SourceType => {
    return mapProductSearchParamToSourceType(
        (getSessionStorageItem(SOURCE_TYPE_KEY) as string) || null,
    );
};
